function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from "react";
import vkPropTypes from "./vkPropTypes";

var CommentsBrowse =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CommentsBrowse, _React$Component);

  function CommentsBrowse() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CommentsBrowse.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mount();
  };

  _proto.mount = function mount() {
    var _this$props = this.props,
        vk = _this$props.vk,
        elementId = _this$props.elementId,
        options = _this$props.options;
    vk.Widgets.CommentsBrowse(elementId, options);
  };

  _proto.render = function render() {
    var elementId = this.props.elementId;
    return React.createElement("div", {
      id: elementId
    });
  };

  return CommentsBrowse;
}(React.Component);

_defineProperty(CommentsBrowse, "defaultProps", {
  elementId: "vk_comments_browse",
  options: {
    height: 0,
    limit: 10,
    mini: "auto",
    norealtime: 0
  }
});

export { CommentsBrowse as default };